import { useFormContext } from 'react-hook-form/dist/index.ie11';
import { IMealCreditFormFields } from 'src/components/oneCorp/features/MealCredit/utils/EnterpriseManageMealCreditsPage.utils';
import { getEmailNotificationSubheader } from 'src/components/oneCorp/features/MealCredit/components/Form/Rules/EmailNotificationRule/hooks/getEmailNotificationSubheader';

export interface UseGetEmailNotificationSubheader {
  subheader: string;
}

export const useGetEmailNotificationSubheader =
  (): UseGetEmailNotificationSubheader => {
    const { watch } = useFormContext<IMealCreditFormFields>();
    const sendLocWelcomeEmail = watch('sendLocWelcomeEmail');

    const subheader = getEmailNotificationSubheader(sendLocWelcomeEmail);

    return {
      subheader,
    };
  };
